module.exports = __webpack_public_path__ + "static/media/014_Fox_Pro.02841781.mp4";